import { Col, Row, Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import { TAB_KEYS } from "@/constants/TabKeys";
import { ContextTabs } from "@/ui/context-tabs";

import TabGeneral from "./Tabs/TabGeneral";
import TabPassword from "./Tabs/TabPassword";

const { Content } = Layout;

const Preferences = () => {
  const { t } = useTranslation();
  const tabs = [
    {
      key: TAB_KEYS.PREFENCES_GENERAL,
      label: t("user:preferences.tabs.general.label"),
      children: <TabGeneral />,
    },
    {
      key: TAB_KEYS.PREFENCES_PASSWORD,
      label: t("user:preferences.tabs.password.label"),
      children: <TabPassword />,
    },
  ];
  return (
    <>
      <BaseHeader title={t("navigation:preferences")} />
      <Content>
        <Row justify="left">
          <Col>
            <ContextTabs
              tabPlacement="left"
              key="preference-tabs"
              items={tabs}
            />
          </Col>
        </Row>
      </Content>
    </>
  );
};

export default Preferences;
